export class ProfilDetailsHorsParcours {
  static Prerequities: any[] = [
    { name: 'JAVA', level: 'Tres Bon niveau' },
    { name: 'POO', level: 'Niveau Intermediaire' },
  ];

  //Pour les candidatures
  static Availability: any[] = [
    { id: 0, value: 'Très limitée (moins de 1h par jour)' },
    { id: 1, value: 'Limitée (entre 1 et 2h par jour)' },
    { id: 2, value: 'Moyennement disponible (entre 2 et 3h par jour)' },
    { id: 3, value: 'Disponible (entre 3 et 4h par jour)' },
    { id: 4, value: ' Très disponible (plus de 4h par jour)' },
  ];

  //Pour les candidatures

  static Discipline: any[] = [
    {
      id: 0,
      name: 'Gestion (commerce, marketing, ressources humaines, etc.) / Économie / Administration ',
    },
    { id: 1, name: 'Sciences de l’information et de la communication ' },
    { id: 2, name: 'Informatique / Télécommunications ' },
    { id: 3, name: 'Santé (médecine, pharmacie, etc.) / Social ' },
    { id: 4, name: 'Mathématiques / Statistiques ' },
    {
      id: 5,
      name: 'Environnement / Géologie / Sciences de la vie (biologie, etc.) ',
    },
    { id: 6, name: 'Sciences du génie ' },
    { id: 7, name: 'Physique / Chimie ' },
    { id: 8, name: 'Architecture Arts / Design / Culture ' },
    { id: 9, name: 'Droit / Science politique ' },
    { id: 10, name: 'Éducation ' },
    { id: 11, name: 'Philosophie / Sociologie / Anthropologie / Psychologie ' },
    { id: 12, name: 'Histoire / Géographie ' },
    { id: 13, name: 'Langues / Littérature / Lettres ' },
    { id: 14, name: 'Autres' },
  ];

  //Pour les candidatures

  static Series: any[] = [
    { id: 0, name: 'S' },
    { id: 1, name: 'F' },
    { id: 2, name: 'G-STEG' },
    { id: 3, name: 'T' },
    { id: 4, name: 'L' },
    { id: 5, name: 'Autre' },
  ];

  //Pour les candidatures
  static Bareme: any[] = [
    { id: 0, name: 'Aucun', value: 1 },
    { id: 1, name: 'Faible', value: 2 },
    { id: 2, name: 'Moyen', value: 3 },
    { id: 3, name: 'Bon', value: 4 },
    { id: 4, name: 'Excellent', value: 5 },
  ];
  //Pour les candidatures
  static OtherStatus: any[] = [
    { id: 0, name: 'Salarié' },
    { id: 1, name: 'Auto-emploi' },
    { id: 2, name: 'Non-diplômé' },
    { id: 3, name: 'Autres' },
  ];

  //Pour les candidatures
  static Student: any[] = [
    { id: 0, name: 'Licence1 ou équivalent' },
    { id: 1, name: 'Licence2 ou équivalent' },
    { id: 2, name: 'Licence3 ou équivalent' },
    { id: 3, name: 'Master1 ou équivalent' },
    { id: 4, name: 'Master2 ou équivalent' },
    { id: 5, name: 'Doctorant' },
    { id: 6, name: 'Autres' },
  ];

  //Pour les candidatures
  static DiplomeForApplications: any[] = [
    { id: 0, name: 'Aucun' },
    { id: 1, name: 'CFEE' },
    { id: 2, name: 'BFEM' },
    { id: 3, name: 'CAP/BEP' },
    { id: 4, name: 'Baccalauréat' },
    { id: 5, name: 'BTS/DUT/DEUG' },
    { id: 6, name: 'Licence (Bac+3)' },
    { id: 7, name: 'Master' },
    { id: 8, name: 'Doctorat' },
  ];
  static Diplomes: any[] = [
    { id: 0, name: 'Aucun' },
    { id: 1, name: 'CFEE' },
    { id: 2, name: 'BFEM' },
    { id: 3, name: 'CAP/BEP' },
    { id: 4, name: 'Baccalauréat' },
    { id: 5, name: 'BTS/DUT/DEUG' },
    { id: 6, name: 'Licence' },
    { id: 7, name: 'Maîtrise' },
    { id: 8, name: 'Master' },
    { id: 9, name: 'Doctorat' },
  ];
  static Specialisations: any[] = [
    { id: 0, name: 'Agriculture et agroalimentaire' },
    { id: 1, name: 'Administration et gestion des entreprises' },
    { id: 2, name: 'Bâtiment et travaux publics' },
    { id: 3, name: 'Commerce et artisanat' },
    { id: 4, name: 'Eau et Énergie' },
    { id: 5, name: 'Finance, Banque et Assurance' },
    { id: 6, name: 'Informatique et télécom' },
    { id: 7, name: 'Mines et Industrie' },
    { id: 8, name: 'Secteur public' },
    { id: 9, name: 'Technologies du digital' },
    { id: 10, name: 'Tourisme' },
    { id: 11, name: 'Transport et logistique' },
    { id: 12, name: 'Sciences humaines et sociales' },
  ];
  static Experiences: any[] = [
    { id: 0, name: '1 an' },
    { id: 1, name: '2 ans' },
    { id: 2, name: '3 ans' },
    { id: 3, name: '4 ans' },
    { id: 4, name: '5 ans' },
    { id: 5, name: 'plus de 5 ans' },
    { id: 6, name: 'plus de 8 ans' },
  ];
  static statutProfessionnels: any[] = [
    { id: 0, name: 'Étudiant' },
    { id: 1, name: 'Stage ou période d’essai' },
    { id: 2, name: 'Employé (CDD, CDI)' },
    { id: 3, name: 'Entrepreneur ou freelance' },
    { id: 4, name: 'Chercheur d’emploi' },
  ];

  //Pour stemd

  static Série4Stemd: any[] = [
    { id: 0, name: 'Enseignement Moyen' },
    { id: 1, name: 'Série S1' },
    { id: 2, name: 'Série S3' },
    { id: 3, name: 'Autres Séries Scientifiques' },
    { id: 4, name: 'Série Technique' },
    { id: 5, name: 'Série Littéraire' },
    { id: 6, name: 'Sérié Tertiaire' },
    { id: 7, name: 'Autre' },
  ];

  static Classe4Stemd: any[] = [
    { id: 0, name: 'Sixième' },
    { id: 1, name: 'Cinquième' },
    { id: 2, name: 'Quatrième' },
    { id: 3, name: 'Troisième' },
    { id: 4, name: 'Seconde' },
    { id: 5, name: 'Première' },
    { id: 6, name: 'Terminale' },
    { id: 7, name: 'Autre' },
  ];

  static Universities: any[] = [
    {
      id: 2,
      name: 'Université numérique Cheikh Hamidou KANE',
    },
    {
      id: 3,
      name: 'Université Sine-Saloum El Hadji Ibrahima Niasse',
    },
    {
      id: 4,
      name: 'Université Assane Seck de Ziguinchor',
    },
    {
      id: 5,
      name: "Institut Supérieur d'Enseignement Professionnel Bignona",
    },
    {
      id: 6,
      name: 'Université Gaston Berger',
    },
    {
      id: 7,
      name: 'Université Cheikh Anta Diop',
    },
    {
      id: 8,
      name: 'Université Alioune Diop de Bambey',
    },
    {
      id: 9,
      name: 'Université Amadou Mahtar Mbow',
    },
    {
      id: 10,
      name: 'Université Iba Der Thiam',
    },
    {
      id: 11,
      name: "Institut Supérieur d'Enseignement Professionnel Thiès",
    },
    {
      id: 12,
      name: "Institut Supérieur d'Enseignement Professionnel Richard Toll",
    },
    {
      id: 13,
      name: "Institut Supérieur d'Enseignement Professionnel Amadou Traware (ex. Isep Diamniadio)",
    },
    {
      id: 14,
      name: "Institut Supérieur d'Enseignement Professionnel Mbacké",
    },
    {
      id: 15,
      name: "Institut Supérieur d'Enseignement Professionnel Matam",
    },
  ];
}
